<div class="search-result-item">
  <span class="search-result-name">{{ result.name }}</span>
  @if (result.categoryName) {
    <span class="search-result-breadcrumb">{{ result.categoryName }}</span>
  }
</div>
